<template>
  <div />
</template>

<script>
import { testWxOpenid } from '@/utils/WXlogin'
export default {
  name: 'Text',
  mounted() {
    testWxOpenid()
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
